import {IProfile} from '@/modules/Profile/interfaces/profile.interface';

export namespace IRequestProfileSet {

  export const ACTION: string = 'contacts_set';

  export enum Commands {
    CONTACTS = 'contacts',
    PASSWORD = 'password',
    EMAIL = 'email',
    CONFIRM_EMAIL = 'confirmEmail',
    CLEAR_NEW_VERSION = 'clearNewVersion',
  }

  export function convertToInputChangePasswordParams(command: Commands, email: string, oldPassword: string, newPassword: string) {
    const result: any = {
      command,
      email: email,
      password: newPassword,
      oldPassword: oldPassword,
    };
    return result;
  }

  export function convertToInputChangeEmailParams (command: Commands, email: string, password: string,) {
    const result: any = {
      command,
      email,
      password
    };
    return result;
  }

  export function convertToInputConfirmEmailParams (command: Commands, confirmGUID: string) {
    const result: any = {
      command,
      confirmGUID
    };
    return result;
  }

  export function convertToOutputResult(data: any): IProfile.ResourceSubmitResponseDataResult {
    return {};
  }

  export function convertToOutputConfirmEmailResult(confirmEmail: string) {
    return {
      confirmEmail: confirmEmail ? confirmEmail : ''
    };
  }

}
